module.exports = __webpack_public_path__ + "img/experiment.cbdb9dc6.svg";